import { useNavigate, useSearchParams } from "react-router-dom"
import PageContainer from "../../components/PageContainer";
import { useEffect, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";
import { emptyCart } from "../../redux/cartSlice";
import { GreenButton } from "../../components/buttons";
const ProductPurchased = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const orderId = searchParams.get('orderId');
    const token = localStorage.getItem('ticino-wild-token');
    const hasFetched = useRef(false);

    useEffect(() => {
        localStorage.removeItem('ticino-wild-cart');
        dispatch(emptyCart());
    }, [dispatch]);

    useEffect(() => {
        if (!orderId || hasFetched.current) return;
        hasFetched.current = true;
        const processOrder = async () => {
            const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
            const options = { method: 'GET', headers };
            try {
                const statusUrl = `${process.env.REACT_APP_SERVER_BASE_URL}/orders/get-order-status/${orderId}`;
                const statusRes = await fetch(statusUrl, options);
                if (!statusRes.ok) {
                    console.error('Errore nel recupero dello status ordine');
                    return;
                }
                const statusData = await statusRes.json();
                if (statusData.status === 'pending') {
                    const emailUrl = `${process.env.REACT_APP_SERVER_BASE_URL}/orders/send-purchase-emails/${orderId}`;
                    const emailRes = await fetch(emailUrl, options);
                    if (!emailRes.ok) {
                        console.error('Errore nell\'invio email fallback');
                    }
                }
            } catch (error) {
                console.error("Errore nel processare l'ordine:", error);
            } finally {
                setTimeout(() => {
                    navigate("/");
                }, 5000);
            }
        };
        processOrder();
    }, [orderId, token, navigate]);

    return (
        <PageContainer items="center">
            <div className="min-h-96 flex flex-col gap-4 justify-center items-center">
                <h3 className="text-[#225424]">{t('ProductPurchased.productsBuyed')}</h3>
                <GreenButton text={t('ProductPurchased.backToShop')} link="/shop" />
            </div>
        </PageContainer>
    )
}
export default ProductPurchased